module.exports = __webpack_public_path__ + "img/frame (134).23a39823.jpg";